/**
 * KEY ART for each game's card on the PlayPop home screens: a small scene in
 * the game's own world, drawn as SVG so it is crisp on a phone and a TV and
 * costs nothing to load. Each card also sets its name in the game's own type.
 */
function unfaithful(id) {
    // A castle on a hill under the moon, one window lit, a crimson banner.
    const stars = [
        [24, 22], [58, 40], [96, 16], [132, 34], [178, 14], [292, 30], [306, 70], [12, 64], [150, 58],
    ]
        .map(([x, y], i) => `<circle cx="${x}" cy="${y}" r="${i % 3 === 0 ? 1.4 : 0.9}" fill="#efe6d4" opacity="${0.4 + (i % 4) * 0.15}"/>`)
        .join("");
    return `<svg viewBox="0 0 320 180" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="A castle under the moon, one window lit">
<defs>
<linearGradient id="${id}-sky" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#16362f"/><stop offset="0.7" stop-color="#0a1714"/><stop offset="1" stop-color="#050d0b"/></linearGradient>
<radialGradient id="${id}-moon" cx="0.5" cy="0.5" r="0.5"><stop offset="0" stop-color="#fbf6ea"/><stop offset="0.7" stop-color="#efe6d4"/><stop offset="1" stop-color="#efe6d4" stop-opacity="0"/></radialGradient>
<radialGradient id="${id}-glow" cx="0.5" cy="0.5" r="0.5"><stop offset="0" stop-color="#f2b705" stop-opacity="0.55"/><stop offset="1" stop-color="#f2b705" stop-opacity="0"/></radialGradient>
</defs>
<rect width="320" height="180" fill="url(#${id}-sky)"/>
${stars}
<circle cx="250" cy="50" r="34" fill="url(#${id}-moon)" opacity="0.35"/>
<circle cx="250" cy="50" r="22" fill="#efe6d4"/>
<circle cx="243" cy="45" r="4" fill="#d9ccae" opacity="0.6"/><circle cx="256" cy="57" r="3" fill="#d9ccae" opacity="0.5"/>
<path d="M0 180 V150 Q60 128 120 136 Q190 146 250 130 Q290 122 320 132 V180 Z" fill="#06100e"/>
<path fill="#030807" d="M70 148 V96 h6 v-6 h6 v6 h6 v-6 h6 v6 h6 V148 Z M110 148 V108 h70 V148 Z M118 108 V70 h5 v-6 h5 v6 h5 v-6 h5 v6 h5 v-6 h5 v6 V108 Z M170 108 V58 l11 -16 l11 16 V108 Z M192 148 V100 h6 v-6 h6 v6 h6 v-6 h6 v6 h6 V148 Z"/>
<path d="M181 42 V30" stroke="#030807" stroke-width="2"/>
<path d="M181 30 h16 l-4 5 l4 5 h-16 Z" fill="#b3203a"/>
<circle cx="145" cy="88" r="16" fill="url(#${id}-glow)"/>
<rect x="141" y="80" width="8" height="12" rx="4" fill="#f2b705"/>
<rect x="179" y="70" width="5" height="9" rx="2.5" fill="#c98a12" opacity="0.7"/>
</svg>`;
}
function finalFew(id) {
    // A wall of a hundred seats, nearly all dark, a few still lit; the 1% rung.
    const lit = new Set([7, 23, 48, 61, 86]);
    const seats = [];
    for (let i = 0; i < 100; i++) {
        const x = 180 + (i % 10) * 13.6;
        const y = 26 + Math.floor(i / 10) * 13.6;
        seats.push(lit.has(i)
            ? `<circle cx="${x}" cy="${y}" r="5" fill="#ffcf3f"/>`
            : `<circle cx="${x}" cy="${y}" r="4.4" fill="none" stroke="#f4f1e8" stroke-opacity="0.16" stroke-width="1.2"/>`);
    }
    return `<svg viewBox="0 0 320 180" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="A hundred seats, five still lit, and the 1% question">
<defs>
<linearGradient id="${id}-bg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#0f2f3c"/><stop offset="1" stop-color="#071c26"/></linearGradient>
<radialGradient id="${id}-glow" cx="0.2" cy="0.3" r="0.6"><stop offset="0" stop-color="#ffcf3f" stop-opacity="0.18"/><stop offset="1" stop-color="#ffcf3f" stop-opacity="0"/></radialGradient>
</defs>
<rect width="320" height="180" fill="url(#${id}-bg)"/>
<rect width="320" height="180" fill="url(#${id}-glow)"/>
${seats.join("")}
<text x="18" y="112" font-family="'Archivo Variable', 'Bricolage Grotesque', system-ui, sans-serif" font-weight="800" font-stretch="120%" font-size="70" fill="#ffcf3f" letter-spacing="-2">1%</text>
<text x="20" y="134" font-family="'Archivo Variable', 'Bricolage Grotesque', system-ui, sans-serif" font-size="11.5" fill="#9fb4bb">of people get this one right</text>
</svg>`;
}
const ART = { unfaithful, finalfew: finalFew };
/** The card art for a game, or null if it has none yet. `id` keeps gradients unique on a page. */
export function gameArt(gameId, id = gameId) {
    return ART[gameId]?.(`art-${id}`) ?? null;
}
//# sourceMappingURL=gameArt.js.map